export default __webpack_public_path__ + "static/om-f96691fa823f937fb3279b02515d4956.svg";